import { Component, Input, OnInit } from '@angular/core';
import { BudgetService } from '../../service/budget.service';

@Component({
  selector: 'apc-summary-modal-product-allocation',
  templateUrl: './product-allocation.component.html',
  styleUrls: ['./product-allocation.component.scss', '../../budget-filler/budget-filler.component.scss']
})
export class ProductAllocationComponent implements OnInit {
  public worklogs: any;
  @Input() orderId: string;
  productsWithHoursAssigned: any = [];
  productsWithoutHoursAssigned: any = [];
  order: any;
  chartData: Array<any> = [];
  totalSpent: any;
  constructor(private budgetService: BudgetService) {}

  ngOnInit(): void {
    this.budgetService.getProductSummaryChart(this.orderId).then((res) => {
      this.order = res.order;
      res.products.forEach(prod => {
        if(prod.hoursResidual === 0) {
          this.productsWithoutHoursAssigned.push(prod);
        } else {
          this.productsWithHoursAssigned.push(prod);
        }
      });

      if (res.products.length > 0) {
        res.products.forEach((el) => {
          this.chartData.push({ name: el.name, value: el.hoursAssigned });
        });
        this.chartData.push({ name: 'Hours residual', value: this.order.hoursResidual });
        this.totalSpent = ((this.order.hoursAssigned / this.order.hoursGlobal) * 100).toFixed(2);
      } else {
        this.totalSpent = 0;
      }
    });
  }

}
